import { COUPON_ACCESS } from "@/helpers/superAdminPermissionConstant";

export default [
    {
        path: "/super-admin/coupon",
        name: "coupon",
        component: () => import("@/views/super-admin/coupon/Coupon.vue"),
        meta: {
          gate: COUPON_ACCESS,
          requiresSuperAdmin: true,
          pageTitle: "Coupon",
          layout: "super-admin",
        },
      },
  ];
  